import { dateTimeToView } from "helpers/date";
import React, { useEffect, useState } from "react";
import { getEstimatedDateForPoint, setEstimatedDateAsPlanned } from "sources/books/bids";

export default function SetEstimatedDateAsPlanned(props) {
    const [loading, setLoading] = useState(true);
    const [estimatedDate, setEstimatedDate] = useState();
    useEffect(() => {
        getEstimatedDateForPoint(props.id, props.bid.id).then((res) => {
            setEstimatedDate(res);
            setLoading(false);
        });
    }, []);
    return (
        <div className={loading ? "loading" : ""}>
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>Поле</th>
                        <th>Значение</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Точка</td>
                        <td>{props.letter}</td>
                    </tr>
                    <tr>
                        <td>Текущая дата</td>
                        <td>{dateTimeToView(props.planEnterDateOffset)}</td>
                    </tr>
                    <tr>
                        <td>Рассчетная дата</td>
                        <td>{dateTimeToView(estimatedDate)}</td>
                    </tr>
                </tbody>
            </table>
            <div className="d-flex justify-content-end">
                <div
                    className="btn btn-sm btn-brand mr-2"
                    onClick={() =>
                        setEstimatedDateAsPlanned({ id: props.id, bidId: props.bid.id }).then(() => {
                            setLoading(true);
                            props.back();
                            props.getItem();
                        })
                    }
                >
                    Изменить
                </div>
                <div className="btn btn-sm btn-secondary" onClick={() => props.back()}>
                    Отменить
                </div>
            </div>
        </div>
    );
}
